import React from 'react';
import SkeletonLoading from '@src/components/SkeletonLoading';
import { Container } from '@src/components/Container';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import './styles.scss';

export default function Loading() {
  return (
    <Container className="subscription-plans-loading" type={ContainerType.BORDERED}>
      <SkeletonLoading className="subscription-plans-loading__one" height="1.6rem" width="18.4rem" />
      <SkeletonLoading className="subscription-plans-loading__two" height="0.8rem" width="10.4rem" />
      <SkeletonLoading className="subscription-plans-loading__three" height="0.8rem" width="100%" />
      <SkeletonLoading className="subscription-plans-loading__four" height="0.8rem" width="10.4rem" />
      <SkeletonLoading className="subscription-plans-loading__five" height="4rem" width="14.4rem" />
      <SkeletonLoading height="0.8rem" width="10.4rem" />
    </Container>
  );
}
